<nz-modal [(nzVisible)]="showProviderModal"
  class="provider-search-modal"
  (nzOnCancel)="handleCancelModal()"
  nzWidth="800px"
  >
  <ng-container *nzModalContent>
    <h4>Seleccionar un proveedor</h4>
    <nz-input-group [nzSuffix]="searchInputIcon" class="search-box-input">
      <input
        name="searchProvider" #searchProvider
        (input)="searchProviders($event)"
        [(ngModel)]="selectedProviderName"
        [autocomplete]="'off'"
        type="text" nz-input placeholder="Buscar proveedor"/>
    </nz-input-group>
    <dx-data-grid
      [dataSource]="providers"
      (onRowClick)="selectProvider($event)"
      [focusedRowEnabled]="true"
      keyExpr="providerKey">
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxi-column dataField="providerKey" caption="Clave" [allowHeaderFiltering]="false">
        </dxi-column>
        <dxi-column dataField="providerFirstName" caption="Nombre" [allowHeaderFiltering]="false">
        </dxi-column>
        <dxi-column dataField="providerType.providerTypeName" caption="Tipo"
        >
      </dxi-column>
      <dxo-load-panel [enabled]="true">
      </dxo-load-panel>
    </dx-data-grid>
  </ng-container>
  <div *nzModalFooter class="modal-footer">
    <button nz-button class="default"
      (click)="handleCancelModal()">Cancelar</button>
    <button nz-button class="default"
      (click)="addProvider()">
      <span nz-icon nzType="plus"></span>
      Agregar nuevo proveedor
    </button>
    <button nz-button nzType="primary" (click)="acceptProvider()" [disabled]="!selectedProvider">Seleccionar proveedor</button>
  </div>
</nz-modal>
<ng-template #searchInputIcon>
  <span nz-icon nzType="search" nzTheme="outline"></span>
</ng-template>
